import { useEffect, useContext, useState } from 'react';

import { AuthContext } from '@/core/auth/AuthContext';
import auth from '@/core/auth/AuthService';
import { getUTCDateDiffInSeconds } from '@/utils/helpers';

export function useCheckSessionHeartbeat() {
  const { currentUser } = useContext(AuthContext);
  const [ sessionExpiresAt, setSessionExpiresAt ] = useState<string | undefined>();
  const tenMinutes = 10 * 60;
  const fiveMinutes = 5 * 60;
  let timeOut: NodeJS.Timeout;

  const checkSessionHeartbeat = async () => {
    if (!currentUser) { return; }
    const { hasSession, expiresAt } = await auth.pingSessionHeartbeat();
    const timeRemainingInSeconds = getUTCDateDiffInSeconds(new Date(expiresAt), new Date());

    if (hasSession && timeRemainingInSeconds < tenMinutes) {
      const timeLeft = timeRemainingInSeconds - fiveMinutes;
      if (timeLeft > 0) {
        timeOut = setTimeout(checkSessionHeartbeat, timeLeft);
      } else {
        setSessionExpiresAt(expiresAt);
      }
    }
    if (!hasSession) { auth.signOut(); };
  };

  useEffect(() => {
    // check initial session details and render notification immediately if session less than 5 minutes
    checkSessionHeartbeat();

    // health check every 5 minutes
    const timer = setInterval(checkSessionHeartbeat, fiveMinutes * 1000);
    return () => {
      clearInterval(timer);
      clearTimeout(timeOut);
    };
  }, [currentUser]);

  return { sessionExpiresAt };
}
